module.exports = __webpack_public_path__ + "img/7.311fbae2.png";